import { language } from "@chef/constants";

export const intl = (
  {
    se: {
      CHANGES_NOT_SAVED: "Vill du spara de valda rätterna?",
      CHANGES_NOT_SAVED_DETAILED:
        "Du har gjort ändringar som inte är sparade, lämnar du sidan går dessa förlorade.",
      LEAVE_WITHOUT_SAVING: "Lämna utan att spara",
      CANCEL: "Avbryt",
      SAVE: "Spara ändringar",
    },

    dk: {
      CHANGES_NOT_SAVED: "Vil du gemme dine valgte retter?",
      CHANGES_NOT_SAVED_DETAILED:
        "Du har foretaget ændringer, der ikke er gemt. Hvis du forlader siden, vil ændringerne gå tabt.",
      LEAVE_WITHOUT_SAVING: "Forlad uden at gemme",
      CANCEL: "Annuller",
      SAVE: "Gem ændringer",
    },

    no: {
      CHANGES_NOT_SAVED: "Vil du lagre de valgte rettene?",
      CHANGES_NOT_SAVED_DETAILED:
        "Du har gjort endringer som ikke er lagret, hvis du forlater siden går disse tapt.",
      LEAVE_WITHOUT_SAVING: "Gå tilbake uten å lagre",
      CANCEL: "Avbryt",
      SAVE: "Lagre endringer",
    },
  } as const
)[language];
